import { put, select, take } from '@redux-saga/core/effects';
import ActionTypes from 'containers/Configurator/constants/selection';
import { displayPlatePanelAction } from 'containers/PlatePanel/actions';
import { makeSelectIsTopPlate } from 'containers/PlatePanel/selectors';

export default function* selectionShelvesFromPlatePanelSaga() {
  while (true) {
    yield take(ActionTypes.SHELVES_SELECTION);
    const topPlate = yield select(makeSelectIsTopPlate());

    if (topPlate) yield put(displayPlatePanelAction(false));
  }
}
